export default "__VITE_ASSET__BRPRMNG$__"